package com.schoolconnect.app.feature.attendance

import com.schoolconnect.app.feature.common.PaginationPolicy

data class AttendanceHistoryLedgerUi(
    val date: String,
    val day: String,
    val status: String,
    val remarks: String
)

data class AttendanceHistoryUiState(
    val isLoading: Boolean = true,
    val errorMessage: String = "",
    val fromDate: String = "",
    val toDate: String = "",
    val selectedStatus: String = "",
    val totalDays: Int = 0,
    val attendancePercentage: Int = 0,
    val presentDays: Int = 0,
    val absentDays: Int = 0,
    val ledger: List<AttendanceHistoryLedgerUi> = emptyList(),
    val totalCount: Int = 0,
    val pageIndex: Int = 0,
    val pageSize: Int = 10
)

sealed interface AttendanceHistoryUiEvent {
    data class FromDateChanged(val value: String) : AttendanceHistoryUiEvent
    data class ToDateChanged(val value: String) : AttendanceHistoryUiEvent
    data class StatusChanged(val value: String) : AttendanceHistoryUiEvent
    data object ApplyClicked : AttendanceHistoryUiEvent
    data object ClearClicked : AttendanceHistoryUiEvent
    data class PageChanged(val pageIndex: Int) : AttendanceHistoryUiEvent
    data class PageSizeChanged(val pageSize: Int) : AttendanceHistoryUiEvent
}
